export default {
    general: {
        person: 'Person',
        role: 'Role',
        quit: 'Sign out',
        search: 'Search',
        cancel: 'Cancel',
        reset: 'Reset',
        next: 'Next',
        back: 'Back',
        selectCert: 'Select certificate',
        print: 'Print',
        dealer: 'Taxpayer',
        inspector: 'Inspector',
        admin: 'Admin',
        actions: 'Actions',
        details: 'Details',
        additional: 'Additional',
        hide: 'Hide',
        name: 'Name',
        create: 'Create',
        createNew: 'Create new',
        add: 'Add',
        edit: 'Edit',
        save: 'Save',
        iin: 'IIN',
        iinbin: 'IIN/BIN',
        select: 'Select an option',
        taxpayerCabinet: 'Вы находитесь в кабинете налогоплательщика',
        attachment: 'Attachment',
        smsCode: 'SMS code',
        smsCodeSended: 'На номер {0} отправлен SMS код, который необходимо ввести здесь для завершения регистрации и получения сертификата.',
        authSuccess: 'You are successfully authenticated!',
        pressToDownload: 'If certificate doesn\'t downloaded automatically, press',
        here: 'here',
        pressToLogin: 'Press "{0}" to log in using certificate.',
        haveNcaCert: 'У меня есть сертификат НУЦ РК',
        noData: 'No data, use',
        enterValue: 'Type for search',
        fromDate: 'From',
        toDate: 'To',
        lastDay: 'Last day',
        last12Hours: 'Last 12 hours',
        lastHour: 'Last hour',
        nextPage: 'Next page',
        prevPage: 'Prev. page'
    },
    menu: {
        home: 'Workstation',
        login: 'Login',
        help: 'Help',
        createReport: 'Create report',
        reports: 'Reports',
        reportDetails: 'Report details',
        reportViewLog: 'View history',
        profile: 'Profile',
        dealers: 'Taxpayers',
        dealerDetails: 'Кабинет налогоплательщика',
        createDealer: 'Add taxpayer',
        editDealer: 'Edit dealer',
        persons: 'Persons',
        createPerson: 'Add person',
        editPerson: 'Edit person',
        audit: 'Audit',
        addressInfo: 'Address information',
        attributes: 'Attributes',
        systemAttributes: 'System attributes',
        kkmAttributes: 'KKM attributes',
        editAttribute: 'Edit attribute',
        tickets: 'Чеки',
        ticketDetails: 'Детали чека',
        sellReturn: 'Возврат',
        moneyPlacements: 'Инкассации/пополнения',
        moneyPlacementDetails: 'Детали инкассации/пополнения',
        kkms: 'KKM',
        blockedKkms: 'Blocked ККМ',
        createKkm: 'Create KKM',
        editKkm: 'Edit ККМ',
        setOfdData: 'Установить данные ОФД',
        startFiscalization: 'Старт фискализации',
        stopFiscalization: 'Стоп фискализации',
        setCashier: 'Установка кассира по умолчанию',
        revokeCert: 'Отзыв сертификата',
        setDealer: 'Привязка налогоплательщика',
        setBlockStatus: 'Блокировка/Разблокировка ККМ',
        setOfdUnblock: 'Разблокировка по данным ОФД',
        setOfdWork: 'Перевод в рабочее состояние',
        setPoint: 'Установка точки продаж'
    },
    role: {
        '1': 'Admin',
        '3': 'Taxpayer',
        '4': 'Inspector',
        '5': 'Operator'
    },
    errors: {
        error: 'Error',
        unknownError: 'Something went wrong, try to call technical support.',
        selectDealer: 'Для просмотра ККМ необходимо выбрать налогоплательщика.',
        cantGetDealerInfo: 'Не удалось получить информацию о налогоплательщике, попробуйте войти снова.',
        cantGetUserInfo: 'Не удалось получить информацию о Вашей персоне, попробуйте войти снова.',
        passwordDontMatch: 'Пароли не совпадают',
        passwordNotValid: 'Пароль не подходит по требованиям системы',
        '3': 'Заданный логин не найден (нет соответствующего сертификата)',
        '101': 'Access denied',
        '102': 'Не все обязательные параметры переданы для выполнения функции',
        '110': 'Нарушение логики переданных данных',
        '111': 'Идентификатор не найден',
        '201': 'Пользователь не найден',
        '202': 'Авторизация Пользователь заблокирован',
        '203': 'Авторизация Превышено количество с неверным паролем',
        '204': 'Invalid login or password',
        '205': 'Пользователь уже существует в системе',
        '207': 'Авторизация должна быть по крипто-ключу',
        '209': 'Не верный SMS код',
        '301': 'Дилер уже есть в системе',
        '306': 'ККМ уже существует',
        '307': 'Налоговая инспекция не найдена',
        '404': 'Page not found',
        '604': 'Криптосервис: Сервер недоступен или данные сформированы некорректно',
        '607': 'Криптосервис: Не найден алиас (логин) в хранилище сертификатов',
        '608': 'Криптосервис: Сертификаты не совпадают',
        '999': 'Нестандартная исключительная ситуация. Необходимо выяснить причину. См. логи.'
    },
    report: {
        type: 'Report type',
        types: {
            default: 'Report',
            REPORT_Z: 'Z-report',
            Z_REPORT: 'Z-report',
            REPORT_X: 'X-report',
            FISCAL_PERIOD_REPORT: 'Фискальный отчет за период',
            CASHIER_REPORT: 'Отчет по кассирам',
            SECTION_REPORT: 'Отчет по секциям'
        },
        viewLog: {
            viewDate: 'Дата и время просмотра отчета'
        },
        createDate: 'Create date',
        shiftNumber: 'Номер смены',
        shiftOpenDate: 'Дата и время открытия смены',
        shiftCloseDate: 'Дата и время закрытия смены',
        cashSum: 'Сумма наличных в кассе',
        revenue: 'Выручка',
        operations: 'Итоги по операциям суммарно по всем отделам',
        sections: 'Итоги по операциям в каждом отделе',
        totalResults: 'Окончательные итоги по операциям',
        closeShiftNonNullableSums: 'Необнуляемые суммы на момент снятия отчёта',
        startShiftNonNullableSums: 'Необнуляемые суммы на начало смены',
        ticketOperations: 'Итоги по чекам по каждой операции',
        moneyPlacements: 'Итоги по операциям с наличными',
        withdrawal: 'Снятие',
        deposit: 'Внесение',
        buy: 'Покупка',
        buy_return: 'Возврат покупки',
        sell: 'Продажа',
        sell_return: 'Возврат продажи',
        count: 'Количество',
        sum: 'Сумма',
        fromDate: 'Начало периода',
        toDate: 'Окончание периода',
        viewHistory: 'История просмотров',
        createdMessage: 'Задача на формирование отчета успешно создана.'
    },
    person: {
        lastname: 'Last name',
        firstname: 'First name',
        middlename: 'Middle name',
        fio: 'ФИО',
        phone: 'Phone',
        login: 'Login',
        newLogin: 'New login',
        password: 'Password',
        newPassword: 'New password',
        confirmPassword: 'Confirm password',
        address: 'Address',
        newAddress: 'New address',
        house: 'House',
        selectRole: 'Select a role',
        enabled: 'Enabled',
        unlimitedTimeoutSession: 'Unlimited session',
        authType: 'Тип авторизации',
        authTypes: {
            '100': 'Password',
            '101': 'Certificate',
            '102': 'Сертификат НУЦ'
        },
        authKey: 'Сертификат для авторизации',
        regdate: 'Дата регистрации',
        updatedMessage: 'Информация о персоне успешно обновлена',
        certRevokeConfirmation: 'Вы действительно хотите отозвать сертификат пользователя "{0}"?',
        certRevokedMessage: 'Сертификат успешно отозван',
        typeIin: 'Введите ИИН/БИН налогоплательщика',
        dealerSetMessage: 'Налогоплательщик успешно привязан',
        passwordChangedMessage: 'Пароль успешно изменен',
        passwordRequirements: 'Должен состоять из латинских букв, включая заглавные, арабских цифр и спецсимволов из этого списка: @$!%*?&_'
    },
    kkm: {
        label: 'KKM',
        cashierCode: 'Код оператора',
        cashierName: 'Наименование оператора',
        cashierSetMessage: 'Кассир-оператор успешно установлен',
        inspectionName: 'Name of tax inspection',
        inspectionCode: 'Код налоговой инспекции',
        registration: 'Registration number',
        identification: 'Идентификационный номер',
        factoryNum: 'Заводской номер',
        timezone: 'Временная зона ККМ',
        cashAmount: 'Текущий остаток по кассе',
        kkmSfdNum: 'Идентификатор в СФД',
        enabled: 'Подключен к СФД',
        ofdConnected: 'Подключен к ОФД',
        openDate: 'Дата начала действия ККМ',
        closeDate: 'Дата окончания действия ККМ',
        startFiscalDate: 'Дата и время начала фискализации',
        kkmId: 'Идентификатор в ОФД',
        ofdToken: 'Токен ОФД',
        ofdSelectString: 'Оператор ОФД',
        selectOfdConnection: 'Выберите оператора ОФД',
        publicKey: 'Публичный ключ ККМ',
        canChangePublicKey: 'Возможность изменить публичный ключ ККМ',
        defaultOperator: 'Оператор по умолчанию',
        isBlocked: 'Заблокирован',
        blocked: 'Признак блокировки',
        blockStatusSetMessage: 'Статус блокировки успешно изменен',
        pointTitle: 'Наименование точки продажи',
        pointAddress: 'Адрес точки продажи',
        house: 'Дом',
        status: 'Статус',
        blockDate: 'Дата блокировки',
        blockMessage: 'Комментарий блокировки',
        ofdStatus: 'Статус ОФД',
        ofdBlockDate: 'Дата блокировки ОФД',
        ofdBlockMessage: 'Комментарий блокировки ОФД',
        register: 'Регистрация',
        unregister: 'Снятие с регистрации',
        comment: 'Комментарий',
        createdMessage: 'ККМ успешно создан. Идентификатор: {0}',
        ofdDataSetMessage: 'Токен ОФД успешно сохранен.',
        toKkmList: 'К списку ККМ',
        pointSetMessage: 'Точка продажи успешно установлена',
        setOfdWorkConfirmation: 'ККМ {0} будет переведен в рабочее состояние.',
        ofdWorkSetMessage: 'ККМ успешно переведен в рабочее состояние.',
        mode: 'Режим',
        programMode: 'Режим программирования',
        programModeUserLabel: 'Выполнено',
        workMode: 'Режим продаж',
        programTask: 'Переход',
        programModeSetMessage: 'Режим программирования успешно установлен',
        workModeSetMessage: 'Режим продаж успешно установлен',
        statusOfdShortName: {
            'READY': 'Онлайн',
            'BLOCKED': 'Заблокирован',
            'ERROR': 'Ошибка',
            'ERROR_TEMP': 'Автономный режим',
            'WAIT_OFD_CONFIRM': 'Подтверждение регистрационных данных'
        },
        statusOfdFullName: {
            'READY': 'В рабочем состоянии',
            'BLOCKED': 'Заблокирован в ОФД',
            'ERROR': 'Остановлен, требуется вмешательство специалиста',
            'ERROR_TEMP': 'Остановлен (временная ошибка)',
            'WAIT_OFD_CONFIRM': 'Подтверждение регистрационных данных'
        },
        statusShortName: {
            'CREATED': 'Создан',
            'READY': 'В работе',
            'WAIT_OFD': 'Ожидание данных ОФД',
            'STOP': 'Снят с учета',
            'CLOSED': 'Закрыт'
        },
        statusFullName: {
            'CREATED': 'Создан в системе',
            'READY': 'В рабочем состоянии',
            'WAIT_OFD': 'Ожидание данных ОФД',
            'STOP': 'Снят с учета',
            'CLOSED': 'Работа ККМ в системе завершена'
        },
        clientStatus: 'Terminal status',
        clientStatusMessage: 'Terminal status Information',
        clientStatusDate: 'Terminal status change date',
        setCanChangePublicKeyConfirmText: 'Вы действительно хотите установить признак регистрации публичного ключа?',
        setCanChangePublicKeySuccess: 'Признак регистрации публичного ключа установлен'
    },
    ticket: {
        shiftDocumentNumber: 'Номер чека в смене',
        offlineTicketNumber: 'Автономный номер чека',
        onlineTicketNumber: 'Фискальный номер чека',
        debet: 'Приход/расход по ККМ',
        totalAmount: 'Сумма чека',
        status: 'Состояние чека',
        cashierName: 'Кассир-оператор',
        txnClientDate: 'Дата транзакции в ККМ',
        operationTypes: {
            default: 'Тип операции',
            SELL: 'Продажа'
        },
        itemName: 'Название',
        section: 'Отдел',
        quantity: 'Количество',
        price: 'Цена',
        total: 'Сумма',
        taken: 'Принято',
        change: 'Сдача',
        sellReturnConfirmation: 'Вы действительно хотите сделать возврат по чеку {0}?',
        sellReturnedMessage: 'Задача на возврат по чеку успешно создана.'
    },
    moneyPlacement: {
        shiftDocumentNumber: 'Порядковый номер в смене',
        shiftNumber: 'Номер смены',
        debet: 'Приход/расход по ККМ',
        amount: 'Сумма пополнения/инкассации',
        txnClientDate: 'Дата транзакции в ККМ',
        collection: 'Инкассация',
        replenishment: 'Пополнение',
        sumOfCollection: 'Сумма инкассации',
        sumOfReplenishment: 'Сумма пополнения'
    },
    dealer: {
        name: 'Наименование',
        industry: 'Вид деятельности',
        updatedMessage: 'Информация о налогоплательщике успешно обновлена',
        regDateTime: 'Дата регистрации',
        phone: 'Номер телефона',
        address: 'Адрес',
        newAddress: 'Новый адрес',
        house: 'Номер дома',
        ndsPayer: 'Является плательщиком НДС',
        ndsCertificateSeries: 'Серия свидетельства НДС',
        ndsCertificateNum: 'Номер свидетельства НДС'
    },
    audit: {
        dateTime: 'Date',
        event: 'Event',
        sysObject: 'Object',
        subject: 'Subject',
        success: 'Success',
        yes: 'Yes',
        no: 'No'
    },
    attribute: {
        code: 'Код атрибута',
        value: 'Значение',
        comment: 'Комментарий',
        updatedMessage: 'Системный параметр успешно обновлен'
    },
    addressInfo: {
        operationType: 'Тип операции',
        selectType: 'Выберите тип объекта, который Вы хотите {0}',
        area: 'Область',
        district: 'Район области',
        city: 'Город',
        cityDistrict: 'Район города',
        microDistrict: 'Микрорайон',
        street: 'Улица',
        house: 'Дом',
        newValue: 'Новое значение',
        addressCreatedMessage: 'Адрес успешно добавлен',
        addressUpdatedMessage: 'Адрес успешно обновлен'
    },
    version: {
        client: 'Client version',
        server: 'Server version'
    }
}
